import React from 'react';

import { GalleryPage } from '@/app/_components/GalleryPage';
import { GalleryPageProps } from './types';

import classes from './index.module.scss';

export const GalleryPageGraphQL: React.FC<GalleryPageProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <GalleryPage galleryPage={props} />
    </div>
  );
};

export default GalleryPageGraphQL;